import React from 'react'
import { TextField, RadioField } from '../fields'
import { YES_NO_OPTIONS } from '../constants'
import {
  StepCard,
  TitleContainer,
  StepIndicator,
  SectionTitle,
  Row,
  FieldWrapper,
} from '../styles'

const OPTIONAL_TEXT = [
  ['taking_medication', 'Are you taking any medication?'],
  ['allergic_medication', 'Are you allergic to any medication?'],
  ['major_illness', 'Have you had any major illness?'],
  ['major_operations', 'Have you had any major operations?'],
  ['serious_accident', 'Have you had any serious accident?'],
  ['hospitalized', 'Have you ever been hospitalized?'],
]

const MedicalHistory = ({ values, setValue, errors }) => (
  <StepCard>
    <TitleContainer>
      <StepIndicator>5</StepIndicator>
      <SectionTitle>Medical History</SectionTitle>
    </TitleContainer>

    <Row>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Primary care physician"
          value={values.primary_care_physician || ''}
          onChange={v => setValue('primary_care_physician', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <RadioField
          label="Are you pregnant?"
          options={YES_NO_OPTIONS}
          value={values.pregnant || ''}
          onChange={v => setValue('pregnant', v)}
        />
      </FieldWrapper>
    </Row>

    <Row>
      <FieldWrapper $basis="100%">
        <RadioField
          label="Are you allergic to latex? *"
          options={YES_NO_OPTIONS}
          value={values.latex_allergic || ''}
          error={errors.latex_allergic}
          onChange={v => setValue('latex_allergic', v)}
        />
      </FieldWrapper>
    </Row>

    {OPTIONAL_TEXT.map(([field, label]) => (
      <Row key={field}>
        <FieldWrapper $basis="100%">
          <TextField
            fullWidth
            label={label}
            value={values[field] || ''}
            onChange={v => setValue(field, v)}
          />
        </FieldWrapper>
      </Row>
    ))}

    <Row>
      <FieldWrapper $basis="100%">
        <RadioField
          label="Have you ever smoked or chewed tobacco? *"
          options={YES_NO_OPTIONS}
          value={values.smoked || ''}
          error={errors.smoked}
          onChange={v => setValue('smoked', v)}
        />
      </FieldWrapper>
    </Row>
  </StepCard>
)

export default MedicalHistory
